import React, { useState } from 'react';

import PackageForm from '@components/ActivePackages/PackageForm';
import NwDrawer from '@components/Gui/NwDrawer';

const AddPackageDrawer = ({ packageName, bookIDs, projectId, onAddedPackage, onClose }) => {
    const [touchForm, setTouchForm] = useState(false);

    return (
        <NwDrawer title="New Package" touchForm={touchForm} onTouchForm={setTouchForm} onClose={onClose}>
            <PackageForm
                bookIDs={bookIDs}
                packageName={packageName}
                projectId={projectId}
                onAddedPackage={onAddedPackage}
                onClose={onClose}
                onTouchForm={setTouchForm}
            />
        </NwDrawer>
    );
};

export default AddPackageDrawer;
